<div class="wallbox-settings-dialog p-4">
  <div class="dialog-header">
    <h2>
      {{ '+INSTALLATIONS.INSTALLATION.WALLBOX.SMART_CHARGING.SETTINGS.TITLE' | translate }}
    </h2>
  </div>

  <mat-dialog-content>
    <div class="settings mt-2">
      <div>
        <div class="settings__section mb-2">
          <ng-container *ngrxLet="batteryCapacity$ | async as feature">
            <h3>
              {{
                '+INSTALLATIONS.INSTALLATION.WALLBOX.SMART_CHARGING.SETTINGS.BATTERY_CAPACITY.TITLE'
                  | translate
              }}
            </h3>
            <mat-form-field appearance="outline" class="full-width">
              <input
                matInput
                [value]="feature | value2: featurePropertyKey.value"
                (change)="updateBatteryCapacity($event)"
                type="number"
              />
              <span class="p-1" matSuffix>{{ feature | unit: featurePropertyKey.value }}</span>
            </mat-form-field>
            <div class="error-message" *ngIf="isBatteryCapacityOutOfRange">
              {{
                '+INSTALLATIONS.INSTALLATION.WALLBOX.SMART_CHARGING.SETTINGS.BATTERY_CAPACITY.ERROR.OUT_OF_RANGE'
                  | translate: { min: batteryCapacityRange.min, max: batteryCapacityRange.max }
              }}
            </div>
          </ng-container>
        </div>

        <div class="settings__section">
          <h3>
            {{
              '+INSTALLATIONS.INSTALLATION.WALLBOX.SMART_CHARGING.SETTINGS.CHARGING_LEVELS.TITLE'
                | translate
            }}
          </h3>

          <div class="charge-level-item">
            <div class="charge-level-header">
              <ng-container *ngrxLet="plugInLevel$ | async as feature">
                <span class="charge-label">{{
                  '+INSTALLATIONS.INSTALLATION.WALLBOX.SMART_CHARGING.SETTINGS.PLUG_IN_LEVEL.TITLE'
                    | translate
                }}</span>
                <mat-form-field mat-select-height-small class="percentage-field">
                  <mat-select
                    [value]="feature?.properties?.value?.value"
                    (selectionChange)="onPlugInLevelChange($event.value)"
                  >
                    <ng-container *ngFor="let level of charginglevels">
                      <mat-option
                        gtm="onSelect"
                        gtmAction="PlugInLevel"
                        gtmCategory="hems"
                        [value]="level"
                        >{{ level }} {{ feature | unit: featurePropertyKey.value }}</mat-option
                      >
                    </ng-container>
                  </mat-select>
                </mat-form-field>
              </ng-container>
            </div>
            <p
              class="charge-description"
              [innerHTML]="
                '+INSTALLATIONS.INSTALLATION.WALLBOX.SMART_CHARGING.SETTINGS.PLUG_IN_LEVEL.DESCRIPTION'
                  | translate
                  | viTrustHtml
              "
            ></p>
          </div>

          <div class="charge-level-item">
            <div class="charge-level-header">
              <span class="charge-label">{{
                '+INSTALLATIONS.INSTALLATION.WALLBOX.SMART_CHARGING.SETTINGS.TARGET_CHARGE_LEVEL.TITLE'
                  | translate
              }}</span>
              <ng-container *ngrxLet="smartChargingMode$ | async as feature">
                <mat-form-field mat-select-height-small class="percentage-field">
                  <mat-select
                    [value]="feature?.properties?.stateOfCharge?.value"
                    (selectionChange)="onTargetChargeLevelChange($event.value)"
                  >
                    <ng-container *ngFor="let level of charginglevels">
                      <mat-option
                        gtm="onSelect"
                        gtmAction="TargetChargeLevel"
                        gtmCategory="hems"
                        [value]="level"
                        >{{ level }}
                        {{ feature | unit: featurePropertyKey.stateOfCharge }}</mat-option
                      >
                    </ng-container>
                  </mat-select>
                </mat-form-field>
              </ng-container>
            </div>
            <p
              class="charge-description"
              [innerHTML]="
                '+INSTALLATIONS.INSTALLATION.WALLBOX.SMART_CHARGING.SETTINGS.TARGET_CHARGE_LEVEL.DESCRIPTION'
                  | translate
                  | viTrustHtml
              "
            ></p>
          </div>
        </div>
      </div>

      <div class="settings__section xl:ml-2 md:mt-2 sm:mt-2">
        <div>
          <div class="section-header">
            <h3>
              {{
                '+INSTALLATIONS.INSTALLATION.WALLBOX.SMART_CHARGING.SETTINGS.CHARGING_WINDOW.TITLE'
                  | translate
              }}
            </h3>
            <ng-container *ngrxLet="smartChargingMode$ | async as feature">
              <mat-form-field mat-select-height-small class="hours-field">
                <mat-select
                  [value]="chargingTimeWindow"
                  (selectionChange)="onChargingTimeWindowChange($event.value)"
                >
                  <ng-container *ngFor="let option of chargingTimeWindowOptions">
                    <mat-option
                      gtm="onSelect"
                      gtmAction="ChargingTimeWindow"
                      gtmCategory="hems"
                      [value]="option"
                    >
                      {{ option | minutesOrHours }}
                    </mat-option>
                  </ng-container>
                </mat-select>
              </mat-form-field>
            </ng-container>
          </div>
          <p class="section-description">
            {{
              '+INSTALLATIONS.INSTALLATION.WALLBOX.SMART_CHARGING.SETTINGS.CHARGING_WINDOW.DESCRIPTION'
                | translate
            }}
          </p>
        </div>

        <div class="charging-options">
          <div class="icon-description">
            <div>
              <h4>
                {{
                  '+INSTALLATIONS.INSTALLATION.WALLBOX.SMART_CHARGING.SETTINGS.CHARGING_WINDOW.TIME_SAVING.TITLE'
                    | translate
                }}
              </h4>
              <p>
                {{
                  '+INSTALLATIONS.INSTALLATION.WALLBOX.SMART_CHARGING.SETTINGS.CHARGING_WINDOW.TIME_SAVING.DESCRIPTION'
                    | translate
                }}
              </p>
            </div>
          </div>

          <div class="icon-description">
            <div>
              <h4>
                {{
                  '+INSTALLATIONS.INSTALLATION.WALLBOX.SMART_CHARGING.SETTINGS.CHARGING_WINDOW.BALANCED.TITLE'
                    | translate
                }}
              </h4>
              <p>
                {{
                  '+INSTALLATIONS.INSTALLATION.WALLBOX.SMART_CHARGING.SETTINGS.CHARGING_WINDOW.BALANCED.DESCRIPTION'
                    | translate
                }}
              </p>
            </div>
          </div>

          <div class="icon-description">
            <div>
              <h4>
                {{
                  '+INSTALLATIONS.INSTALLATION.WALLBOX.SMART_CHARGING.SETTINGS.CHARGING_WINDOW.COST_SAVING.TITLE'
                    | translate
                }}
              </h4>
              <p>
                {{
                  '+INSTALLATIONS.INSTALLATION.WALLBOX.SMART_CHARGING.SETTINGS.CHARGING_WINDOW.COST_SAVING.DESCRIPTION'
                    | translate
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end" class="dialog-actions">
    <button mat-button (click)="onCancel()" type="button">
      {{ 'GENERAL.BUTTON.CANCEL' | translate }}
    </button>
  </mat-dialog-actions>
</div>
